module.exports = __webpack_public_path__ + "static/fleur_gran_opening_1-663x1024-427fafa3e856d0df69e30e74c1aa5927.jpg";